module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Bold-Alphabetic.759eb6aa.woff";